
import {defineComponent} from "vue";

export default defineComponent({
  name: 'PolicyLayout',
  components: {},
  setup: function () {
    return {}
  },
})
